import Dropdown from "@/components/shared/inputs/DropDown";
import DataTable from "@/components/table/Table";
import * as Icons from "@/assets/features/requistion";
import StatusBadge from "@/components/shared/badges/Badge";
import { useNavigate } from "react-router-dom";
import Wrapper from "@/components/shared/Wrapper";
import HeaderTable from "@/components/table/HeaderTable";
import Filters from "../components/requisitionManagement/Filter";
import HeaderPage from "@/components/layout/HeaderPage";
import { useClientSideTableSlice } from "@/hooks/useClientSideTableSlice";

const MOCK_HISTORY_ROWS = [
  {
    id: "hist-req-1",
    requisition: "Software Engineer",
    requisitionDate: "2023-08-15",
    status: "request-modification",
    approverName: "John Doe",
    approvalDate: "2023-08-20",
    jobPostStatus: "hiring",
  },
  {
    id: "hist-req-2",
    requisition: "Data Scientist",
    requisitionDate: "2023-08-20",
    status: "pending",
    approverName: "Jane Doe",
    approvalDate: "2023-08-25",
    jobPostStatus: "not hiring",
  },
];

const RequestsHistory = () => {
  const navigate = useNavigate();

  const { data, count } = useClientSideTableSlice(MOCK_HISTORY_ROWS);

  const columns = [
    {
      header: "requisition",
      accessorKey: "requisition",
      cell: (row) => (
        <div className="text-primary font-medium">{row.getValue()}</div>
      ),
    },
    {
      header: "requisition date",
      accessorKey: "requisitionDate",
    },
    {
      header: "approval status",
      accessorKey: "status",
      cell: (row) =>
        row.getValue("status") === "request-modification" ? (
          <StatusBadge status={"pending"} text={row.getValue("status")} />
        ) : (
          <StatusBadge status={"secondary"} text={row.getValue("status")} />
        ),
    },
    {
      header: "approver name",
      accessorKey: "approverName",
    },
    {
      header: "approval date",
      accessorKey: "approvalDate",
    },
    {
      header: "job post status",
      accessorKey: "jobPostStatus",
    },
    {
      header: "Actions",
      cell: () => (
        <div className="flex justify-center ">
          <button
            type="button"
            className="flex items-center gap-2 cursor-pointer"
            onClick={() => navigate("/job-requisition/view")}
          >
            <Icons.Eye className="w-5 h-5" /> View
          </button>
        </div>
      ),
    },
  ];
  return (
    <>
      <HeaderPage pageTitle={"requisition management"} view />

      <Wrapper className={"mt-[1.5rem] mb-10 py-[2rem] px-[1.5rem]"}>
        <HeaderTable title={"requests history"} filter={<Filters history={false} />} />

        <div className="mt-7">
          <DataTable
            showCheckbox={false}
            showPagination
            count={count}
            columns={columns}
            data={data}
          />
        </div>
      </Wrapper>
    </>
  );
};

export default RequestsHistory;
